import { render } from "./AppTop.vue?vue&type=template&id=5a3d465d"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/AppTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a3d465d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a3d465d', __exports__)) {
    api.reload('5a3d465d', __exports__)
  }
  
  module.hot.accept("./AppTop.vue?vue&type=template&id=5a3d465d", () => {
    api.rerender('5a3d465d', render)
  })

}


export default __exports__